import { render, staticRenderFns } from "./AwaitingFiles.vue?vue&type=template&id=6834df62&"
import script from "./AwaitingFiles.vue?vue&type=script&lang=js&"
export * from "./AwaitingFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports